import * as Yup from 'yup';

const generalInformationValidationSchema = Yup.object().shape({
  names: Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
  }),
});

export default generalInformationValidationSchema;